// extracted by mini-css-extract-plugin
export default {"container":"IconCard_container__EEmz1","icon":"IconCard_icon__bjQKk","title":"IconCard_title__WCtKY","divider":"IconCard_divider__oQ0uE","infos":"IconCard_infos__tyQHY"};